/** Fields cleared whenever the reminder popover closes. */
export function closedPickerSession() {
  return {
    draftDate: null,
    editingId: null,
    note: '',
    startHint: '',
    step: 'time',
    pickerMode: 'choose',
    initialMode: 'choose',
    recurDraft: null,
    recurSeed: null,
  };
}

export function addPickerSession(isLocked) {
  return {
    ...closedPickerSession(),
    step: isLocked ? 'menu' : 'time',
  };
}

export function editPickerSession(reminder) {
  const base = {
    ...closedPickerSession(),
    note: reminder.note || '',
    editingId: reminder.id,
    step: 'time',
  };
  if (reminder.recur) {
    return {
      ...base,
      recurSeed: reminder.recur,
      initialMode: 'recurring',
      pickerMode: 'recurring',
    };
  }
  return {
    ...base,
    draftDate: new Date(reminder.at),
    initialMode: 'date',
    pickerMode: 'date',
  };
}
